import { useMutation } from '@tanstack/react-query';
import { downloadParkingContractAttachment } from '../../api/parking-contract.ts';

export default function useDownloadParkingContractAttachment() {
  return useMutation({
    mutationFn: async ({
      partnerId,
      contractId,
      attachmentId,
    }: {
      partnerId: string;
      contractId: string;
      attachmentId: string;
    }) => {
      const response = await downloadParkingContractAttachment(
        partnerId,
        contractId,
        attachmentId,
      );
      return response.data.downloadUrl;
    },
  });
}
